import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSleutelAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00215B"
      d="M13.05 25.28c-.98 0-1.97-.21-2.89-.64l.42-.91c1.42.66 3.01.73 4.48.19a5.82 5.82 0 0 0 3.3-3.03l.91.42a6.8 6.8 0 0 1-3.86 3.55c-.77.28-1.56.42-2.36.42"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m21.37 17.7 8.6 13.12L23.59 35l-2.79-4.25 2.13-1.39-5.81-8.87c-3.05.75-6.38-.45-8.2-3.23a7.62 7.62 0 0 1 2.2-10.56 7.62 7.62 0 0 1 10.56 2.2 7.63 7.63 0 0 1-.31 8.8m-7.46-6.75c-1.17.77-1.5 2.35-.73 3.52s2.35 1.5 3.52.73 1.5-2.35.73-3.52a2.546 2.546 0 0 0-3.52-.73"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M21.89 15.91 33 26.99l-5.39 5.4-3.6-3.59 1.8-1.8-7.51-7.49A7.629 7.629 0 0 1 9.61 7.24a7.629 7.629 0 0 1 12.29 8.67zm-8.69-5.08c-.99.99-.99 2.6 0 3.6s2.6.99 3.6 0c.99-.99.99-2.6 0-3.6s-2.6-.99-3.6 0"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M10.17 24.64a6.82 6.82 0 0 1-3.55-3.87c-.63-1.72-.55-3.58.22-5.24a6.8 6.8 0 0 1 3.86-3.55c1.72-.63 3.58-.55 5.24.22l-.42.91a5.8 5.8 0 0 0-4.48-.19 5.82 5.82 0 0 0-3.3 3.03 5.8 5.8 0 0 0-.19 4.48 5.82 5.82 0 0 0 3.03 3.3l-.42.91z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSleutelAanvragen);

export default ForwardRef;
